export default __webpack_public_path__ + "static/media/G0003.09e7d0d3.png";